import create from 'zustand';

export enum ModalNames {
  PORTFOLIO_MANAGED_BY_ADVISOR = 'PORTFOLIO_MANAGED_BY_ADVISOR',
  TRANSFER_STOCK_TO_ADVISOR_PORTFOLIO = 'TRANSFER_STOCK_TO_ADVISOR_PORTFOLIO',
  TRANSFER_STOCK_FROM_ADVISOR_PORTFOLIO = 'TRANSFER_STOCK_FROM_ADVISOR_PORTFOLIO',
}

interface ModalParams {
  onSubmit?: () => void;
}

interface ModalState {
  activeModal: ModalNames | null;
  modalParams: ModalParams | null;
  openModal: (
    modalName: ModalNames,
    params?: ModalParams,
  ) => void;
  closeModal: () => void;
}

const useModalStore = create<ModalState>((set) => ({
  activeModal: null,
  modalParams: null,
  openModal: (modalName, params = null) =>
    set({ activeModal: modalName, modalParams: params }),
  closeModal: () =>
    set({ activeModal: null, modalParams: null }),
}));

export default useModalStore;
